// import { on, fetchCart } from 'slater/cart'
// import { getSizedImageUrl, imageSize } from 'slater/images'
// import { formatMoney } from 'slater/currency'
//
// const X = `<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentcolor" stroke-width="3" style="display:inline-block;vertical-align:middle;overflow:visible;"><path d="M1.0606601717798212 1.0606601717798212 L14.939339828220179 14.939339828220179"></path><path d="M14.939339828220179 1.0606601717798212 L1.0606601717798212 14.939339828220179"></path></svg>`
//
// function createItem ({
//   variant_id: id,
//   product_title: title,
//   line_price: price,
//   variant_title: color,
//   image,
//   url,
//   quantity,
//   ...item
// }) {
//   const img = image ? getSizedImageUrl(
//     image.replace('_' + imageSize(image), ''), '200x' // TODO hacky af
//   ) : 'https://source.unsplash.com/R9OS29xJb-8/2000x1333'
//
//   return `
// <div class='cart-drawer__item' data-component='cart-drawer-item' data-id=${id} data-qty=${quantity}>
//   <div class='f aic rel'>
//     <div class='__content_image'>
//       <a href='${url}'>
//         <img src='${img}' />
//       </a>
//     </div>
//     <div class='__content pl1 f fill-x ais jcb'>
//       <div class='f jcb aic fill-x'>
//         <div class='__content_info'>
//           <a href='${url}' class='mv0 p1 bold mv0'>${title}</a>
//           <div class='f aic'>
//             <div class='cart-quantity js-remove-single px05'>-</div>
//             <div class='js-single-quantity'>${quantity}</div>
//             <div class='cart-quantity js-add-single px05'>+</div>
//           </div>
//           ${color ? `<div class='xsmall sans caps track cm mv025 book'>${color.split(':')[0]}</div>` : ``}
//         </div>
//         <div class='__cart_price'>
//           <div class='small track mx0 bold'><span class='money'>${formatMoney(price)}</span></div>
//         </div>
//       </div>
//
//       <button class='button--reset abs fit-r'>${X}</button>
//     </div>
//   </div>
// </div>
// `
// }
//
// function renderItems (items) {
//   return items.length > 0 ? (
//     items.reduce((markup, item) => {
//       markup += createItem(item)
//       return markup
//     }, '')
//   ) : (
//     `<div class='pv1'><p class='p15 mt1 sussie small cb i ac'>Your cart is empty</p></div>`
//   )
// }
//
// function preFillUrl (items) {
//   return items.length > 0 ? (
//     items.reduce((url, item, index) => {
//       url += `${item.id}:${item.quantity}${(index !== (items.length - 1)) ? ',' : ''}`
//       return url
//     }, '')
//   ) : ''
// }
//
// function renderSubTotal (cost, items) {
//   return items.length > 0 ? (
//     `<h6 class='mv1 ls b ac'>Subtotal <span class='money'>${cost}</span></h6>`
//   ) : ''
// }
//
// export default outer => {
//   let isOpen = false
//
//   const overlay = outer.querySelector('.js-overlay')
//   const closeButton = outer.querySelector('.js-close')
//   const sub = outer.querySelector('.js-sub')
//   const itemsRoot = outer.querySelector('.js-items')
//   const urlButton = outer.querySelector('.js-prefill-url')
//   const loading = itemsRoot.innerHTML
//
//   function render () {
//     fetchCart().then(cart => {
//       // let cartToken = cart.token
//       let preFill = preFillUrl(cart.items)
//       itemsRoot.innerHTML = renderItems(cart.items)
//       sub.innerHTML = renderSubTotal(formatMoney(cart.total_price), cart.items)
//
//       urlButton.addEventListener('click', (e) => {
//         window.location.href = `/cart/${preFill}`
//       })
//     })
//   }
//
//   function open () {
//     outer.classList.add('is-active')
//
//     itemsRoot.innerHTML = loading
//
//     setTimeout(() => {
//       outer.classList.add('is-visible')
//       isOpen = true
//       setTimeout(render, 10)
//     }, 50)
//   }
//
//   function close () {
//     outer.classList.remove('is-visible')
//
//     setTimeout(() => {
//       outer.classList.remove('is-active')
//       isOpen = false
//     }, 400)
//   }
//
//   on('updated', ({ cart }) => {
//     isOpen ? render() : open()
//   })
//   on('addon', ({ cart }) => {
//     isOpen ? render() : open()
//   })
//   overlay.addEventListener('click', close)
//   closeButton.addEventListener('click', close)
//   // cartToggle.addEventListener('click', () => {
//   //   open()
//   // })
//
//   return {
//     open,
//     close: close
//   }
// }



// WEBPACK FOOTER //
// ./src/scripts/components/__cart-drawer.js